import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana77Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
  
  <rect width="1221" height="921" fill="url(#pattern0_1462_13003)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M487.799 333.56L500.906 362.144L455.032 383.272L436.682 347.231L468.139 332.317C477.576 326.352 485.178 330.66 487.799 333.56Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M396.879 365.288L436.277 347.306L454.666 384.556L408.696 406.392C404.755 398.257 397.404 384.299 394.252 378.133C391.099 371.968 394.689 367.001 396.879 365.288Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M516.765 398.91L499.82 361.776L454.199 384.322L472.448 422.781L516.765 398.91Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M426.831 446.654L472.452 422.783L454.204 384.323L408.583 406.868L426.831 446.654Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M443.777 485.102L426.832 446.643L472.454 422.771L490.702 461.231L443.777 485.102Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M535.02 438.695L516.771 398.909L472.453 422.781L490.702 461.24L535.02 438.695Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M460.72 523.559L443.775 485.1L490.7 461.229L507.645 499.688L460.72 523.559Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M553.265 477.139L507.644 499.684L490.699 461.225L535.017 438.68L553.265 477.139Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M570.208 514.277L553.263 477.144L507.642 499.689L525.89 538.148L570.208 514.277Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M478.971 562.018L525.896 538.147L507.647 499.688L460.723 523.559L478.971 562.018Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M495.917 600.477L478.972 562.018L525.897 538.146L542.842 576.606L495.917 600.477Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M588.462 552.735L570.214 514.275L525.896 538.147L542.841 576.606L588.462 552.735Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M606.709 592.52L588.46 552.734L542.839 576.606L561.087 615.065L606.709 592.52Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M515.463 638.937L495.911 600.478L542.836 576.606L561.084 615.066L515.463 638.937Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M528.501 666.787L515.467 638.937L561.088 615.065L579.337 653.525C571.081 657.945 552.225 667.848 542.84 672.091C533.455 676.335 530.239 670.323 528.501 666.787Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M617.137 634.959L579.336 653.526L561.088 615.067L606.709 592.521L621.047 621.698C623.133 629.124 619.309 633.633 617.137 634.959Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1462_13003" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1462_13003" transform="matrix(0.00176188 0 0 0.0023354 -3.42322 -1.41234)"/>
    </pattern>
    <image id="image0_1462_13003" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};